var ChannelAvailability = /* @__PURE__ */ ((ChannelAvailability2) => {
  ChannelAvailability2["ONLINE"] = "ONLINE";
  ChannelAvailability2["IN_STORE_ONLY"] = "IN_STORE_ONLY";
  return ChannelAvailability2;
})(ChannelAvailability || {});
export {
  ChannelAvailability
};
//# sourceMappingURL=product.js.map
